const moment = require('moment')

const secondsOnPageSession = session => {
  const enterDate = moment(session.page.enterDate)
  const leaveDate = moment(session.page.leaveDate)

  return leaveDate.diff(enterDate, 's')
}

module.exports = secondsOnPageSession
